import script from "./DownloadModelCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadModelCard.vue?vue&type=script&setup=true&lang=js"

import "./DownloadModelCard.vue?vue&type=style&index=0&id=25cde010&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cde010"]])

export default __exports__